import { useMutation } from '@tanstack/react-query';

import { PostLoginPayload, PostLoginResponse } from '@/api/userAccount/types';
import { axios } from '@/common/axios';
import { MutationConfig, queryClient } from '@/common/react-query';
import { uriEncodeObjectProperties } from '@/utils';

export const postLogin = (payload: PostLoginPayload): Promise<PostLoginResponse> => {
    // we have to encodeURIComponent the values because API expects it and performs a decodeURIComponent on the values
    return axios.post('/login', uriEncodeObjectProperties(payload));
};

type UsePostLoginOptions = {
    config?: MutationConfig<typeof postLogin>;
    data?: PostLoginPayload;
};

export const usePostLogin = ({ config }: UsePostLoginOptions = {}) => {
    return useMutation({
        ...config,
        mutationFn: postLogin,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['validate-data-connection'] });
        },
    });
};
